import { Flex, Text, Box } from "@radix-ui/themes";
import { cn } from "@/shared/utils/cn";

interface LastFetchedInfoProps {
  isStale: boolean;
  timeElapsed: string;
  hasNoJourneys?: boolean;
}

export const LastFetchedInfo = ({
  isStale,
  timeElapsed,
  hasNoJourneys = false,
}: LastFetchedInfoProps) => {
  if (hasNoJourneys) {
    return (
      <Flex align="center" gap="2">
        <Text size="1" color="gray">
          Complete journey annotations to see the predicted cart
        </Text>
      </Flex>
    );
  }

  return (
    <Flex align="center" gap="2">
      <Text size="1" color="gray">
        Last updated:{" "}
        <Box
          as="span"
          className={cn("inline-block text-left", isStale && "text-red-600")}
        >
          {timeElapsed} ago
        </Box>
      </Text>
    </Flex>
  );
};
